module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/es-abstract/helpers/isPrimitive.js
// module id = 1508
// module chunks = 168707334958949